import { render, staticRenderFns } from "./ManageIncidentStatusForm.vue?vue&type=template&id=22760e4a&scoped=true"
import script from "./ManageIncidentStatusForm.vue?vue&type=script&lang=js"
export * from "./ManageIncidentStatusForm.vue?vue&type=script&lang=js"
import style0 from "./ManageIncidentStatusForm.vue?vue&type=style&index=0&id=22760e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22760e4a",
  null
  
)

export default component.exports